import React from 'react';
import styled from 'styled-components';

const NumberIcon = styled.svg`
  height: ${({ theme }) => theme.unit(5)};
  width: ${({ theme }) => theme.unit(5)};
`;

export const No1Icon = () => (
  <NumberIcon xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
    <path
      d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
      fill="#AAE8FF"
    />
    <path
      d="M18.1257 28.793V14.4082L17.3638 14.7641C16.343 15.2405 15.1294 14.7992 14.653 13.7785C14.1767 12.7577 14.6179 11.5441 15.6387 11.0677L19.3026 9.3579C19.9343 9.0631 20.673 9.11127 21.261 9.48572C21.8489 9.86022 22.2047 10.509 22.2047 11.2061V28.793C22.2047 29.9194 21.2916 30.8325 20.1652 30.8325C19.0387 30.8325 18.1257 29.9194 18.1257 28.793Z"
      fill="#005587"
    />
  </NumberIcon>
);

export const No2Icon = () => (
  <NumberIcon xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
    <path
      d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
      fill="#AAE8FF"
    />
    <path
      d="M22.8133 16.0912C22.8133 14.5196 21.5391 13.2455 19.9675 13.2455C18.3959 13.2455 17.1217 14.5196 17.1217 16.0912C17.1217 17.2177 16.2087 18.1307 15.0822 18.1307C13.9558 18.1307 13.0427 17.2177 13.0427 16.0912C13.0427 12.2668 16.143 9.1665 19.9675 9.1665C23.792 9.1665 26.8923 12.2668 26.8923 16.0912C26.8923 19.1663 25.2668 21.7192 23.319 23.8943C22.464 24.849 21.477 25.8033 20.4393 26.7534H24.9172C26.0436 26.7534 26.9572 27.6665 26.9572 28.7929C26.9572 29.9193 26.0436 30.8325 24.9172 30.8325H15.0823C14.2378 30.8325 13.4809 30.3121 13.1782 29.5238C12.8757 28.7354 13.0901 27.8418 13.7178 27.2768C16.2619 24.9871 18.5457 23.1097 20.28 21.1731C21.9961 19.2568 22.8133 17.6572 22.8133 16.0912Z"
      fill="#005587"
    />
  </NumberIcon>
);

export const No3Icon = () => (
  <NumberIcon xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
    <path
      d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
      fill="#AAE8FF"
    />
    <path
      d="M22.3574 23.9077C22.3574 22.3361 21.0832 21.0619 19.5116 21.0619C18.3852 21.0619 17.4721 20.1489 17.4721 19.0224C17.4721 17.9312 18.329 17.0399 19.4067 16.9853L19.5116 16.9829L19.608 16.9805C20.5952 16.9304 21.3804 16.1139 21.3804 15.1142C21.3804 14.0822 20.5437 13.2455 19.5116 13.2455C18.8108 13.2455 18.197 13.6305 17.8753 14.2101C17.3287 15.1951 16.0875 15.5505 15.1025 15.004C14.1176 14.4575 13.7622 13.2162 14.3087 12.2312C15.3204 10.408 17.2696 9.1665 19.5116 9.1665C22.7965 9.1665 25.4593 11.8293 25.4593 15.1142C25.4593 16.5045 24.9805 17.7817 24.1813 18.7944C25.5671 20.0606 26.4364 21.8826 26.4364 23.9077C26.4364 27.7322 23.3361 30.8325 19.5116 30.8325C17.2451 30.8325 15.2327 29.7415 13.9728 28.0645C13.2962 27.1638 13.4777 25.8853 14.3783 25.2087C15.2789 24.5321 16.5575 24.7136 17.2341 25.6142C17.7567 26.3098 18.5821 26.7534 19.5116 26.7534C21.0833 26.7534 22.3574 25.4793 22.3574 23.9077Z"
      fill="#005587"
    />
  </NumberIcon>
);

export const NumberComponents = {
  No1Icon,
  No2Icon,
  No3Icon,
};
